/**
 * 后端URL处理工具类
 * 用于处理后端API和静态资源的完整URL
 */

// 后端基础URL常量
// 从环境变量获取后端基础地址，提供默认值作为回退
const BACKEND_BASE_URL = process.env.VUE_APP_BACKEND_URL

/**
 * 获取完整的后端URL，补充backend前缀
 * @param {string} path - 相对路径或完整URL
 * @returns {string} 完整的URL
 */
export function getBackendUrl(path) {
  if (!path) return ''

  // 如果已经是完整URL，直接返回
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path
  }

  // 如果是相对路径，添加基础URL
  return `${BACKEND_BASE_URL}/${path.replace(/^\//, '')}`
}

export default {
  getBackendUrl,
}